const LANGUAGE_STORAGE_KEY = 'worknest.admin.lang';
/** When set, UI language was explicitly chosen (switcher); do not override from API on login. */
const LANGUAGE_USER_CHOSEN_KEY = 'worknest.admin.lang.userChosen';

export type SupportedLanguage = 'en-US' | 'ar-SA';

/** WorkNest supports Arabic and English only; anything else (including retired fr/es) is English. */
export const normalizeStoredLanguage = (lang: string): SupportedLanguage =>
  lang.toLowerCase().startsWith('ar') ? 'ar-SA' : 'en-US';

export const readStoredLanguage = (): SupportedLanguage | undefined => {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return stored ? normalizeStoredLanguage(stored) : undefined;
  } catch {
    return undefined;
  }
};

export const writeStoredLanguage = (lang: string): void => {
  try {
    const normalized = normalizeStoredLanguage(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  } catch {
    // Ignore storage failures.
  }
};

export const readLanguageUserChosen = (): boolean => {
  try {
    return localStorage.getItem(LANGUAGE_USER_CHOSEN_KEY) === '1';
  } catch {
    return false;
  }
};

export const markLanguageUserChosen = (): void => {
  try {
    localStorage.setItem(LANGUAGE_USER_CHOSEN_KEY, '1');
  } catch {
    // Ignore storage failures.
  }
};
